import React from 'react';

import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import { IconButton, Skeleton } from '@mui/material';

import useStyles from './styles';

interface Props {
    loading?: boolean;
    className?: string;
    href: string;
    value: string | number;
    description: string;
}

const StatisticWidget: React.FC<Props> = ({ loading, value, description, href, className }) => {
    const { classes, cx } = useStyles();
    return (
        <div className={cx(classes.container, className)}>
            <div className={classes.content}>
                {loading ? (
                    <Skeleton variant="text" sx={{ lineHeight: `36px` }} />
                ) : (
                    <span className={classes.value}>{value}</span>
                )}
                {loading ? (
                    <Skeleton variant="text" sx={{ lineHeight: `16px` }} />
                ) : (
                    <span className={classes.description}>{description}</span>
                )}
            </div>
            <IconButton
                href={href}
                target="_blank"
                rel="nofollow noreferrer"
                color="inherit"
                className={classes.button}
                disabled={loading}
            >
                <ArrowOutwardIcon />
            </IconButton>
        </div>
    );
};

export default StatisticWidget;
